module.exports = __webpack_public_path__ + "img/17_29.491a4b58.png";